import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Components
import Login from './components/Login';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Employees from './pages/Employees';
import Attendance from './pages/Attendance';
import MyTimeOff from './pages/MyTimeOff';
import WhosOut from './pages/WhosOut';
import Fleet from './pages/Fleet';
import Dispatch from './pages/Dispatch';
import RoutesPage from './pages/Routes';
import MessageBoard from './pages/MessageBoard';
import DirectMessages from './pages/DirectMessages';
import Calendar from './pages/Calendar';
import ABCSchool from './pages/ABCSchool';
import Certifications from './pages/Certifications';
import Reports from './pages/Reports';
import HumanResources from './pages/HumanResources';
import Payroll from './pages/Payroll';
import WebsiteCMS from './pages/WebsiteCMS';
import AppManagement from './pages/AppManagement';
import Settings from './pages/Settings';
import Display from './pages/Display';
import Users from './pages/Users';
import Accidents from './pages/Accidents';
import Support from './pages/Support';
import HandbookEditor from './pages/HandbookEditor';
import CelebrationsBoard from './pages/CelebrationsBoard';
import CelebrationsDisplay from './pages/CelebrationsDisplay';
import PasswordVault from './pages/PasswordVault';
import Expenses from './pages/Expenses';
import ExpensesAdmin from './pages/ExpensesAdmin';
import ExpenseDetail from './pages/ExpenseDetail';
import ScanReceipt from './pages/ScanReceipt';
// Auth Phase 2 (P2-B): public token pages — raw fetch, no auth imports (ScanReceipt precedent)
import ForgotPassword from './pages/ForgotPassword';
import TokenPasswordPage from './pages/TokenPasswordPage';

// Context
import { AuthProvider } from './context/AuthContext';
import { PermissionProvider } from './context/PermissionContext';
import ProtectedRoute from './components/ProtectedRoute';
import SessionLostModal from './components/SessionLostModal';

// Styles
import './App.css';

function App() {
  return (
    <AuthProvider>
      <PermissionProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/display" element={<Display />} />
              <Route path="/celebrations-display" element={<CelebrationsDisplay />} />
              <Route path="/scan/:token" element={<ScanReceipt />} />
              <Route path="/forgot" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<TokenPasswordPage kind="reset" />} />
              <Route path="/welcome/:token" element={<TokenPasswordPage kind="welcome" />} />

              {/* Protected Routes */}
              <Route path="/" element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }>
                <Route index element={<Dashboard />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="employees" element={<Employees />} />
                <Route path="attendance" element={<Attendance />} />
                <Route path="time-off" element={<MyTimeOff />} />
                <Route path="whos-out" element={<WhosOut />} />
                <Route path="fleet" element={<Fleet />} />
                <Route path="dispatch" element={<Dispatch />} />
                <Route path="routes" element={<RoutesPage />} />
                <Route path="accidents" element={<Accidents />} />
                <Route path="message-board" element={<MessageBoard />} />
                <Route path="celebrations-board" element={<CelebrationsBoard />} />
                <Route path="direct-messages" element={<DirectMessages />} />
                <Route path="calendar" element={<Calendar />} />
                <Route path="abc-school" element={<ABCSchool />} />
                <Route path="certifications" element={<Certifications />} />
                <Route path="reports" element={<Reports />} />
                <Route path="hr" element={<HumanResources />} />
                <Route path="handbook-editor" element={<HandbookEditor />} />
                <Route path="payroll" element={<Payroll />} />
                <Route path="website-cms" element={<WebsiteCMS />} />
                <Route path="app-management" element={<AppManagement />} />
                <Route path="users" element={<Users />} />
                <Route path="settings" element={<Settings />} />
                <Route path="support" element={<Support />} />
                <Route path="password-vault" element={<PasswordVault />} />
                <Route path="expenses" element={<Expenses />} />
                <Route path="expenses/admin" element={<ExpensesAdmin />} />
                <Route path="expenses/:id" element={<ExpenseDetail />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <SessionLostModal />
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="dark"
            />
          </div>
        </Router>
      </PermissionProvider>
    </AuthProvider>
  );
}

export default App;
